import { useCallback, useEffect, useRef, useState } from 'react';
import './Slider.scss';

interface Props {
  initialValue?: number;
  labels?: string[];
  onSliderChange: (value: number) => void;
}

export const Slider = ({
  initialValue = 0,
  labels = [],
  onSliderChange,
}: Props) => {
  const sliderRef = useRef<any>();

  const [sliderValue, setSliderValue] = useState(0);

  // paint slider

  function paintSlider(sliderElm: any, value: number) {
    if (!sliderElm) return;
    // apply yellow color only to the left side of the slider
    const percentualValue = Math.round(value * 100);
    const colorLeft = '#F5C005';
    const colorRight = '#444';
    sliderElm.style.background = `linear-gradient(to right, ${colorLeft} ${percentualValue}%, ${colorRight} ${percentualValue}%)`;
  }

  // reset slider to 0 on start

  useEffect(() => {
    setSliderValue(initialValue);
    paintSlider(sliderRef.current, initialValue);
  }, [initialValue]);

  // handle slider change

  const handleSliderChange = useCallback((e: any) => {
    const value = e.currentTarget.value;
    paintSlider(e.currentTarget, value);
    setSliderValue(value);
    onSliderChange(value);
  }, []);

  // render slider
  return (
    <div className="slider-all">
      {/* labels */}
      <div className="slider-labels">
        {labels.map((label, index) => {
          return (
            <div key={index} className="slider-label">
              {label}
            </div>
          );
        })}
      </div>

      {/* slider */}
      <div className="slider-container">
        <input
          ref={sliderRef}
          className="slider"
          type="range"
          min={0.0}
          max={1.0}
          step={0.01}
          value={sliderValue}
          id="myRange"
          onInput={handleSliderChange}
        />
      </div>
    </div>
  );
};
